import { fetchUtils, Admin, Resource } from 'react-admin';
import jsonServerProvider from 'ra-data-json-server';
import { createBrowserHistory as createHistory } from 'history';
import { TourCreate } from './tourdetails.js';
import { CompleteCreate } from './complete.js';
import LamsLayout from './LamsLayout';


import ReactGA from 'react-ga4';
  const TRACKING_ID = "G-89ZMFV5GJL"; 
  ReactGA.initialize(TRACKING_ID);

  const httpClient = (url, options = {}) => {
    if (!options.headers) {
      options.headers = new Headers({ Accept: 'application/json' });
    }
    options.mode = 'cors';
    return fetchUtils.fetchJson(url, options);
  }

const providerURL = process.env.REACT_APP_GO_CONNECT_URL
// console.log("providerurl " + providerURL)
const dataProvider = jsonServerProvider(providerURL, httpClient);
const history = createHistory();



const App = () => {

  return (
    <Admin disableTelemetry  history={history}  dataProvider={dataProvider} layout={LamsLayout}>
      <Resource options={{ label: 'Tour' }} name="tours/TourDetails"  create={TourCreate} />
      <Resource name="tours/Complete"  create={CompleteCreate} />
    </Admin>
  );

}

export default App;

